import murmurhash from 'murmur-128'

/*
 * ImprintJs
 */
const _tests = {}
const imprint = {
  test: function(tests) {
    return Promise.all(tests.map(function(x) {
      if (!Object.prototype.hasOwnProperty.call(_tests, x)) { throw new Error('No test registered with the alias ' + x) }
      return _tests[x]()
    })).then(function(values) {
      // console.log(values);
      // return murmur.murmurHash3.x86.hash128(values.join('~'))
      return murmurhash(values.join('~'))
    })
  },

  registerTest: function(alias, test) {
    // Add test factory to tests collection
    _tests[alias] = test
  }
}

imprint.registerTest('adBlocker', function() {
  return new Promise(function(resolve) {
    const adsbox = document.createElement('div')
    adsbox.innerHTML = '&nbsp;'
    adsbox.className = 'adsbox'
    adsbox.style.display = 'block'
    adsbox.style.position = 'absolute'
    adsbox.style.top = '0px'
    adsbox.style.left = '-9999px'
    try {
      // body may not exist, that's why we need try/catch
      document.body.appendChild(adsbox)
      window.setTimeout(function() {
        const result = adsbox.offsetHeight === 0
        document.body.removeChild(adsbox)
        return resolve(result)
      }, 10)
    }
    catch (e) {
      return resolve(false)
    }
  })
})

/*
* Original Source: https://github.com/Song-Li/cross_browser/blob/master/client/fingerprint/js/audio.js
* Copyright: Yinzhi Cao, Song Li, Erik Wijmans
* License: GNU v3
* Changes:
*  - Wrapped in an ImprintJs promise
*/

imprint.registerTest('audio', function() {
  return new Promise(function(resolve) {
    try {
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)()
      // eslint-disable-next-line no-unused-vars
      const oscillator = audioCtx.createOscillator()
      // eslint-disable-next-line no-unused-vars
      const analyser = audioCtx.createAnalyser()
      // eslint-disable-next-line no-unused-vars
      const gainNode = audioCtx.createGain()
      // eslint-disable-next-line no-unused-vars
      const scriptProcessor = audioCtx.createScriptProcessor(4096, 1, 1)
      const destination = audioCtx.destination
      const val = (audioCtx.sampleRate).toString() + '_' + destination.maxChannelCount + '_' + destination.numberOfInputs + '_' + destination.numberOfOutputs + '_' + destination.channelCount + '_' + destination.channelCountMode + '_' + destination.channelInterpretation
      return resolve(val)
    }
    catch (e) {
      return resolve('')
    }
  })
})

imprint.registerTest('availableScreenResolution', function() {
  return new Promise(function(resolve) {
    const val = (window.screen.availHeight > window.screen.availWidth)
      ? [window.screen.availHeight, window.screen.availWidth]
      : [window.screen.availWidth, window.screen.availHeight]
    return resolve(val.join('x'))
  })
})

/*
* Original Source: https://github.com/Valve/fingerprintjs2/blob/master/fingerprint2.js
* Copyright: Valentin Vasilyev (valentin.vasilyev@outlook.com)
* License: MIT
* Changes:
*  - Wrapped in an ImprintJs promise
*/

imprint.registerTest('canvas', function() {
  return new Promise(function(resolve) {
    const result = []

    // Very simple now, need to make it more complex (geo shapes etc)
    const canvas = document.createElement('canvas')
    canvas.width = 2000
    canvas.height = 200
    canvas.style.display = 'inline'

    const ctx = canvas.getContext('2d')

    // detect browser support of canvas winding
    // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    ctx.rect(0, 0, 10, 10)
    ctx.rect(2, 2, 6, 6)
    result.push('canvas winding:' + ((ctx.isPointInPath(5, 5, 'evenodd') === false) ? 'yes' : 'no'))

    ctx.textBaseline = 'alphabetic'
    ctx.fillStyle = '#f60'
    ctx.fillRect(125, 1, 62, 20)
    ctx.fillStyle = '#069'

    // https://github.com/Valve/fingerprintjs2/issues/66
    ctx.font = '11pt no-real-font-123'
    ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 2, 15)
    ctx.fillStyle = 'rgba(102, 204, 0, 0.2)'
    ctx.font = '18pt Arial'
    ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 4, 45)

    // canvas blending
    // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    ctx.globalCompositeOperation = 'multiply'
    ctx.fillStyle = 'rgb(255,0,255)'
    ctx.beginPath()
    ctx.arc(50, 50, 50, 0, Math.PI * 2, true)
    ctx.closePath()
    ctx.fill()
    ctx.fillStyle = 'rgb(0,255,255)'
    ctx.beginPath()
    ctx.arc(100, 50, 50, 0, Math.PI * 2, true)
    ctx.closePath()
    ctx.fill()
    ctx.fillStyle = 'rgb(255,255,0)'
    ctx.beginPath()
    ctx.arc(75, 100, 50, 0, Math.PI * 2, true)
    ctx.closePath()
    ctx.fill()
    ctx.fillStyle = 'rgb(255,0,255)'

    // canvas winding
    // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    ctx.arc(75, 75, 75, 0, Math.PI * 2, true)
    ctx.arc(75, 75, 25, 0, Math.PI * 2, true)
    ctx.fill('evenodd')

    result.push('canvas fp:' + canvas.toDataURL())

    return resolve(result.join('~'))
  })
})

imprint.registerTest('colorDepth', function() {
  return new Promise(function(resolve) {
    let cd = window.screen.colorDepth

    // Some browsers return 24 rather than 32 as 32 is really
    // 24 bit color depth + 8 bits alpha, so they see the alpha
    // as not really being "color" so report 24 instead.
    // For consistancy, treat all 32 color depths as 24.
    if (cd === 32) {
      cd = 24
    }

    return resolve(cd || '')
  })
})

imprint.registerTest('cookies', function() {
  return new Promise(function(resolve) {
    return resolve(navigator.cookieEnabled)
  })
})

imprint.registerTest('cpuClass', function() {
  return new Promise(function(resolve) {
    return resolve(navigator.cpuClass || '')
  })
})

imprint.registerTest('deviceDpi', function() {
  return new Promise(function(resolve) {
    return resolve((window.screen.deviceXDPI || 0) + 'x' + (window.screen.deviceYDPI || 0))
  })
})

imprint.registerTest('doNotTrack', function() {
  return new Promise(function(resolve) {
    return resolve(navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack || '')
  })
})

imprint.registerTest('indexedDb', function() {
  return new Promise(function(resolve) {
    try {
      return resolve(!!window.indexedDB)
    }
    catch (e) {
      return resolve(true) // SecurityError when referencing it means it exists
    }
  })
})

/**
 * JavaScript code to detect available availability of a
 * particular font in a browser using JavaScript and CSS.
 *
 * Author : Lalit Patel
 * Website: http://www.lalit.org/lab/javascript-css-font-detect/
 * License: Apache Software License 2.0
 *          http://www.apache.org/licenses/LICENSE-2.0
 * Version: 0.15 (21 Sep 2009)
 *          Changed comparision font to default from sans-default-default,
 *          as in FF3.0 font of child element didn't fallback
 *          to parent element if the font is missing.
 * Version: 0.2 (04 Mar 2012)
 *          Comparing font against all the 3 generic font families ie,
 *          'monospace', 'sans-serif' and 'sans'. If it doesn't match all 3
 *          then that font is 100% not available in the system
 * Version: 0.3 (24 Mar 2012)
 *          Replaced sans with serif in the list of baseFonts
 */
const FontDetector = function() {
  // a font will be compared against all the three default fonts.
  // and if it doesn't match all 3 then that font is not available.
  const baseFonts = ['monospace', 'sans-serif', 'serif']

  // we use m or w because these two characters take up the maximum width.
  // And we use a LLi so that the same matching fonts can get separated
  const testString = 'mmmmmmmmmmlli'

  // we test using 72px font size, we may use any size. I guess larger the better.
  const testSize = '201px'

  const h = document.getElementsByTagName('body')[0]

  // create a SPAN in the document to get the width of the text we use to test
  const s = document.createElement('span')
  s.style.fontSize = testSize
  s.innerHTML = testString
  const defaultWidth = {}
  const defaultHeight = {}
  for (const index in baseFonts) {
    // get the default width for the three base fonts
    s.style.fontFamily = baseFonts[index]
    h.appendChild(s)
    defaultWidth[baseFonts[index]] = s.offsetWidth // width for the default font
    defaultHeight[baseFonts[index]] = s.offsetHeight // height for the defualt font
    h.removeChild(s)
  }

  function detect(font) {
    let detected = true
    for (const index in baseFonts) {
      s.style.fontFamily = font + ',' + baseFonts[index] // name of the font along with the base font for fallback.
      h.appendChild(s)
      const matched = (s.offsetWidth !== defaultWidth[baseFonts[index]] || s.offsetHeight !== defaultHeight[baseFonts[index]])
      h.removeChild(s)
      detected = detected && matched
    }
    return detected
  }

  this.detect = detect
}

imprint.registerTest('installedFonts', function() {
  return new Promise(function(resolve) {
    const fontDetective = new FontDetector()
    // Firefox doesn't like fonts ending in "bold", "heavy", "light", "transparent" or anything vaguely css related so we make sure the list doesn't contain any such fonts
    const fontArray = ['ADOBE CASLON PRO', 'ADOBE GARAMOND PRO', 'AVENIR', 'Adobe Fangsong Std', 'Adobe Ming Std', 'Agency FB', 'Aharoni', 'Amazone BT', 'AngsanaUPC', 'Antique Olive', 'Apple Chancery', 'Apple Color Emoji', 'Apple SD Gothic Neo', 'Arab', 'Arial Baltic', 'Arial CE', 'Arial CYR', 'Arial Greek', 'Arial MT', 'Arial Unicode MS', 'Arrus BT', 'AvantGarde Bk BT', 'AvantGarde Md BT', 'Ayuthaya', 'Baskerville Old Face', 'Bell MT', 'Benguiat Bk BT', 'Berlin Sans FB', 'BernhardFashion BT', 'BernhardMod BT', 'Big Caslon', 'Bitstream Vera Sans Mono', 'Bitstream Vera Serif', 'BlairMdITC TT', 'Bodoni 72 Smallcaps', 'Bodoni MT Poster Compressed', 'Boulder', 'Bradley Hand', 'Broadway', 'Browallia New', 'BrowalliaUPC', 'Calisto MT', 'Cambria Math', 'Centaur', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charter BT', 'ChelthmITC Bk BT', 'Chiller', 'Comic Sans MS', 'Constantia', 'Copperplate', 'Corbel', 'Cordia New', 'CordiaUPC', 'Coronet', 'Courier New Baltic', 'Courier New CE', 'Courier New CYR', 'Courier New TUR', 'Cuckoo', 'DFKai-SB', 'DaunPenh', 'Dauphin', 'David', 'DejaVu LGC Sans Mono', 'Denmark', 'Desdemona', 'DokChampa', 'Dotum', 'Ebrima', 'Edwardian Script ITC', 'Eras Bold ITC', 'EucrosiaUPC', 'Euphemia', 'Eurostile', 'FRUTIGER', 'FangSong', 'Felix Titling', 'Forte', 'Fransiscan', 'FreesiaUPC', 'French Script MT', 'FrnkGothITC Bk BT', 'Fruitger', 'Futura Bk BT', 'Futura Md BT', 'Futura ZBlk BT', 'FuturaBlack BT', 'Galliard BT', 'Garamond', 'Gautami', 'Geeza Pro', 'Geneva', 'GeoSlab 703 Lt BT', 'Geometr231 BT', 'Geometr231 Hv BT', 'Gigi', 'Gill Sans', 'GoudyOLSt BT', 'GulimChe', 'GungSeo', 'Gurmukhi MN', 'Harlow Solid Italic', 'Heather', 'HeiT', 'High Tower Text', 'Hiragino Kaku Gothic ProN', 'Hiragino Mincho ProN', 'Hiragino Sans GB', 'Hoefler Text', 'Humanst521 BT', 'Humanst521 Lt BT', 'Impact', 'Imprint MT Shadow', 'Incised901 BT', 'Incised901 Lt BT', 'Informal Roman', 'Informal011 BT', 'IrisUPC', 'Kabel Bk BT', 'KacstOne', 'KaiTi', 'Khmer UI', 'Kokila', 'LUCIDA GRANDE', 'Latha', 'Leelawadee', 'Lohit Gujarati', 'Long Island', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lydian BT', 'MS Gothic', 'MS Mincho', 'MS PGothic', 'MS Reference Sans Serif', 'MS Reference Specialty', 'MS Serif', 'MUSEO', 'MYRIAD', 'Malgun Gothic', 'Mangal', 'Marigold', 'Market', 'Marlett', 'Meiryo', 'Meiryo UI', 'Menlo', 'Microsoft PhagsPa', 'Microsoft Uighur', 'MingLiU', 'MingLiU_HKSCS', 'Minion', 'Miriam Fixed', 'Mona Lisa Solid ITC TT', 'Monaco', 'Monotype Corsiva', 'NEVIS', 'News Gothic', 'News GothicMT', 'NewsGoth BT', 'Nyala', 'Old Century', 'Old English Text MT', 'Onyx', 'Oriya Sangam MN', 'PMingLiU', 'Palatino', 'Parchment', 'Pegasus', 'Perpetua', 'Perpetua Titling MT', 'Pickwick', 'Poster', 'Pristina', 'Raavi', 'Rage Italic', 'Rockwell', 'Roman', 'Sakkal Majalla', 'Savoye LET', 'Sawasdee', 'Segoe UI Symbol', 'Serifa BT', 'Serifa Th BT', 'Showcard Gothic', 'Shruti', 'Signboard', 'SimHei', 'SimSun', 'SimSun-ExtB', 'Simplified Arabic', 'Simplified Arabic Fixed', 'Sinhala Sangam MN', 'Sketch Rockwell', 'Socket', 'Stencil', 'Styllo', 'Swis721 BlkEx BT', 'Swiss911 XCm BT', 'Symbol', 'Synchro LET', 'System', 'TRAJAN PRO', 'Technical', 'Teletype', 'Tempus Sans ITC', 'Thonburi', 'Times', 'Times New Roman Baltic', 'Times New Roman CYR', 'Times New Roman PS', 'Trebuchet MS', 'Tubular', 'Tunga', 'Tw Cen MT', 'TypoUpright BT', 'Ubuntu', 'Unicorn', 'Utopia', 'Viner Hand ITC', 'Vivaldi', 'Vrinda', 'Westminster', 'Wide Latin', 'Zurich BlkEx BT']
    // Extend the fontArray to cover the following for a larger list of fonts, however it will take loger to calculate the fingerprint
    /* "ARCHER","ARNO PRO","Academy Engraved LET","Adobe Garamond","Adobe Hebrew","Algerian","AmerType Md BT","American Typewriter","Andale Mono","Andalus","Angsana New","Aparajita","Arabic Typesetting","Arial","Arial Hebrew","Arial TUR","Aurora Cn BT","Bandy","Bangla Sangam MN","Bank Gothic","BankGothic Md BT","Baskerville","Batang","BatangChe","Bauer Bodoni","Bembo","BinnerD","Blackadder ITC","Bodoni MT","Bradley Hand ITC","Braggadocio","Bremen Bd BT","Brush Script MT","CG Omega","CG Times","Calibri","Californian FB","Calligrapher","Cambria","Candara","CaslonOpnface BT","Castellar","Casual","Century","Century Gothic","Century Schoolbook","Cezanne","Charlesworth","Chaucer","Clarendon","CloisterBlack BT","Cochin","Colonna MT","Comic Sans","CopperplGoth Bd BT","Copperplate Gothic","Cornerstone","Courier New Greek","Curlz MT","DB LCD Temp","Didot","DilleniaUPC","DotumChe","Elephant","English 111 Vivace BT","Engravers MT","EngraversGothic BT","Eras Demi ITC","Estrangelo Edessa","Euphemia UCAS","Exotc350 Bd BT","FONTIN","Fixedsys","FrankRuehl","Freefrm721 Blk BT","Futura","Futura Lt BT","GOTHAM","Gabriola","GeoSlab 703 XBd BT","Geometr231 Lt BT","Georgia","Gill Sans MT","Gisha","Goudy Stout","GoudyHandtooled BT","Gujarati Sangam MN","Gulim","Gungsuh","GungsuhChe","Haettenschweiler","Harrington","Hei S","Heisei Kaku Gothic","Heiti SC","Heiti TC","Helvetica","Helvetica Neue","Herald","Humanst 521 Cn BT","Incised901 Bd BT","Iskoola Pota","JasmineUPC","Jazz LET","Jenson","Jester","Jokerman","Juice ITC","Kailasa","Kalinga","Kannada Sangam MN","Kartika","Kaufmann BT","Kaufmann Bd BT","Kino MT","KodchiangUPC","Korinna BT","Kozuka Gothic Pr6N","Kristen ITC","Krungthep","Lao UI","Letter Gothic","Levenim MT","LilyUPC","Lithograph","Loma","Lucida Handwriting","Lucida Sans Unicode","MS LineDraw","MS Outlook","MS PMincho","MS Sans Serif","MS UI Gothic","MT Extra","MV Boli","MYRIAD PRO","Maiandra GD","Malayalam Sangam MN","Marion","Marker Felt","Matisse ITC","Matura MT Script Capitals","Microsoft Himalaya","Microsoft JhengHei","Microsoft New Tai Lue","Microsoft Sans Serif","Microsoft Tai Le","Microsoft YaHei","Microsoft Yi Baiti","MingLiU-ExtB","MingLiU_HKSCS-ExtB","Minion Pro","Miriam","Mistral","Modern","Mongolian Baiti","MoolBoran","Mrs Eaves","NSimSun","Nadeem","Narkisim","News Gothic MT","Niagara Engraved","Niagara Solid","Noteworthy","OCR A Extended","Onyx BT","OzHandicraft BT","PMingLiU-ExtB","PRINCETOWN LET","PTBarnum BT","Palace Script MT","Palatino Linotype","Papyrus","Party LET","Plantagenet Cherokee","Playbill","Poor Richard","PosterBodoni BT","Pythagoras","Rachana","Ravie","Ribbon131 Bd BT","Rod","Santa Fe LET","Sceptre","Segoe Print","Segoe UI","Serifa","ShelleyVolante BT","Sherwood","Shonar Bangla","Skia","Small Fonts","Snap ITC","Snell Roundhand","Souvenir Lt BT","Staccato222 BT","Steamer","Storybook","Subway","Sylfaen","Tahoma","Tamil Sangam MN","Telugu Sangam MN","Terminal","Times New Roman","Times New Roman CE","Times New Roman Greek","Times New Roman TUR","TlwgMono","Traditional Arabic","Trajan","Tristan","Umpush","Univers","Utsaah","Vagabond","Vani","Verdana","Vijaya","VisualUI","WHITNEY","Webdings","ZWAdobeF","ZapfEllipt BT","ZapfHumnst BT","ZapfHumnst Dm BT","Zapfino","Zurich Ex BT"];*/
    const installedFontsArray = []

    for (let i = 0; i < fontArray.length; i++) {
      if (fontDetective.detect(fontArray[i])) {
        installedFontsArray.push(fontArray[i])
      }
    }

    // console.log(installedFontsArray.join(", "))

    return resolve(installedFontsArray.join('~'))
  })
})

/*
* Original Source: https://github.com/Song-Li/cross_browser/blob/master/client/fingerprint/js/languageDetector.js
* Copyright: Yinzhi Cao, Song Li, Erik Wijmans
* License: GNU v3
* Changes:
*  - Icreased font size
*  - Use span + inline styles for measurement div
*  - Inserted comments
*  - Wrapped in an ImprintJs promise
*/

/*
This test renders to a canvas a whole bunch of words in 36 different
alphabets to test which alphabets the user has installed on their computer.
The words are kept in the 2D array called codes in their UTF-16 format
to ensure that they aren't interpreted before it is time to render them
The 37th string in codes is a single character that we are hoping will
always show up as a cannot be displayed character.

While wether the alphabet can be displayed or not is deteremined by the
operating system, the symbol used to represent cannot be displayed is
deteremined by the browser.  However, it does seem like it is always some
sort of box
*/

const safeParseJSON = function(s) {
  try {
    return JSON.parse(s)
  }
  catch (error) {
    return false
  }
}

const LanguageDetector = (function() {
  function LanguageDetector() {
    this.names = safeParseJSON('[ "Latin", "Chinese", "Arabic", "Devanagari", "Cyrillic", "Bengali/Assamese", "Kana", "Gurmukhi", "Javanese", "Hangul", "Telugu", "Tamil", "Malayalam", "Burmese", "Thai", "Sundanese", "Kannada", "Gujarati", "Lao", "Odia", "Ge-ez", "Sinhala", "Armenian", "Khmer", "Greek", "Lontara", "Hebrew", "Tibetan", "Georgian", "Modern Yi", "Mongolian", "Tifinagh", "Syriac", "Thaana", "Inuktitut", "Cherokee" ]')
    this.codes = safeParseJSON('[[76,97,116,105,110], [27721,23383], [1575,1604,1593,1585,1576,1610,1577], [2342,2375,2357,2344,2366,2327,2352,2368], [1050,1080,1088,1080,1083,1080,1094,1072], [2476,2494,2434,2482,2494,32,47,32,2437,2488,2478,2496,2479,2492,2494], [20206,21517], [2583,2625,2608,2606,2625,2582,2624], [43415,43438], [54620,44544], [3108,3142,3122,3137,3095,3137], [2980,2990,3007,2996,3021], [3374,3378,3375,3390,3379,3330], [4121,4156,4116,4154,4121,4140], [3652,3607,3618], [7070,7077,7060,7082,7059], [3221,3240,3277,3240,3233], [2711,2753,2716,2736,2750,2724,2752], [3749,3762,3751], [2825,2852,2893,2837,2867], [4877,4821,4829], [3523,3538,3458,3524,3517], [1344,1377,1397,1400,1409], [6017,6098,6040,6082,6042], [917,955,955,951,957,953,954,972], [6674,6682,6664,6673], [1488,1500,1508,1489,1497,1514], [3926,3964,3921,3851], [4325,4304,4320,4311,4323,4314,4312], [41352,41760], [6190,6179,6185,6189,6179,6191], [11612,11593,11580,11593,11599,11568,11606], [1808,1834,1825,1821,1808], [1931,1960,1928,1964,1920,1960], [5123,5316,5251,5198,5200,5222], [5091,5043,5033], [55295, 7077]]')
    this.fontSize = 401
    this.fontFace = 'Verdana'
    this.extraHeigth = 15
    this.res = []
  }

  LanguageDetector.prototype.begin = function() {
    let c, code, h, height, i, j, k, l, len, len1, len2, len3, len4, len5, len6, len7, m, n, o, p, round, s, w, width
    round = 0
    this.widths = []
    this.heights = []
    this.support = []
    this.test_div = document.createElement('div')
    document.body.appendChild(this.test_div)
    this.test_div.id = 'WritingTest'
    const ref = this.codes
    for (i = 0, len = ref.length; i < len; i++) {
      code = ref[i]
      this.height = []
      this.width = []
      this.div = document.createElement('div')
      this.test_div.appendChild(this.div)
      round += 1
      this.div.id = round
      this.div.style.display = 'inline-block'
      for (j = 0, len1 = code.length; j < len1; j++) {
        c = code[j]
        this.div.innerHTML = "<span style = 'font-family:" + this.fontFace + '; font-size:' + this.fontSize + "px;'>&#" + c + '</span>'
        this.height.push(document.getElementById(round).clientHeight)
        this.width.push(document.getElementById(round).clientWidth)
      }
      this.div.innerHTML = ''
      for (k = 0, len2 = code.length; k < len2; k++) {
        c = code[k]
        this.div.innerHTML += "<span style = 'font-family:" + this.fontFace + '; font-size:' + this.fontSize + "px;'>&#" + c + '</span>'
      }
      this.test_div.innerHTML += this.height + ';' + this.width + '<br>'
      this.heights.push(this.height)
      this.widths.push(this.width)
    }

    // standard width
    // maybe with a circle
    this.tw = this.widths.pop()
    this.sw1 = this.tw[0]
    this.sw2 = this.tw[1]

    // Standard height
    this.sh = this.heights.pop()[0]

    // Check the height
    const ref1 = this.heights
    for (l = 0, len3 = ref1.length; l < len3; l++) {
      height = ref1[l]
      this.passed = 0
      for (m = 0, len4 = height.length; m < len4; m++) {
        h = height[m]
        if (h !== this.sh) {
          this.support.push(true)
          this.passed = 1
          break
        }
      }
      if (this.passed === 0) {
        this.support.push(false)
      }
    }

    // Check the width
    this.writing_scripts_index = 0
    const ref2 = this.widths
    for (n = 0, len5 = ref2.length; n < len5; n++) {
      width = ref2[n]
      for (o = 0, len6 = width.length; o < len6; o++) {
        w = width[o]
        if (this.support[this.writing_scripts_index] === false) {
          if (w !== this.sw1 && w !== this.sw2) {
            this.support[this.writing_scripts_index] = true
          }
        }
      }
      this.writing_scripts_index += 1
    }

    this.res = []
    this.writing_scripts_index = 0
    const ref3 = this.support
    for (p = 0, len7 = ref3.length; p < len7; p++) {
      s = ref3[p]
      this.test_div.innerHTML += this.names[this.writing_scripts_index] + ': ' + s + ' <br>'
      if (s === true) {
        this.res.push(this.names[this.writing_scripts_index])
      }
      this.writing_scripts_index += 1
    }
    this.test_div.remove()
    return this.res
  }

  return LanguageDetector
})()

imprint.registerTest('installedLanguages', function() {
  return new Promise(function(resolve) {
    try {
      const detector = new LanguageDetector()
      return resolve(detector.begin().join('~'))
    }
    catch (e) {
      return resolve('')
    }
  })
})

imprint.registerTest('language', function() {
  return new Promise(function(resolve) {
    return resolve(navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '')
  })
})

imprint.registerTest('localIp', function() {
  return new Promise(function(resolve) {
    try {
      const RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection // compatibility for firefox and chrome
      const pc = new RTCPeerConnection({ iceServers: [] }); const noop = function() {}
      pc.createDataChannel('') // create a bogus data channel
      pc.createOffer(pc.setLocalDescription.bind(pc), noop) // create offer and set local description
      pc.onicecandidate = function(ice) { // listen for candidate events
        pc.onicecandidate = noop

        if (!ice || !ice.candidate || !ice.candidate.candidate) {
          return resolve('')
        }

        // var val = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
        const val = /^ |((?:[0-9A-Za-z]{1,8}))-((?:[0-9A-Za-z]{1,4}))-((?:[0-9A-Za-z]{1,4}))-((?:[0-9A-Za-z]{1,4}))-((?:[0-9A-Za-z]{1,12}))*.((?:[0-9A-Za-z]{1,5}))| $/.exec(ice.candidate.candidate)[1]
        return resolve(val)
      }
    }
    catch (e) {
      return resolve('')
    }
  })
})

imprint.registerTest('localStorage', function() {
  return new Promise(function(resolve) {
    try {
      return resolve(!!window.localStorage)
    }
    catch (e) {
      return resolve(true) // SecurityError when referencing it means it exists
    }
  })
})

imprint.registerTest('mediaDevices', function() {
  return new Promise(function(resolve) {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      const cd = window.screen.colorDepth
      return resolve(cd || '')
    }

    navigator.mediaDevices.enumerateDevices()
      .then(function(devices) {
        const results = devices.map(function(device) {
          return device.kind + ':' + device.label + ' id = ' + device.deviceId
        })
        return resolve(results.join(','))
      })
      .catch(_err => resolve(''))
  })
})

imprint.registerTest('pixelRatio', function() {
  return new Promise(function(resolve) {
    return resolve(window.devicePixelRatio || '')
  })
})

imprint.registerTest('platform', function() {
  return new Promise(function(resolve) {
    return resolve(navigator.platform || '')
  })
})

/*
* Original Source: https://github.com/Valve/fingerprintjs2/blob/master/fingerprint2.js
* Copyright: Valentin Vasilyev (valentin.vasilyev@outlook.com)
* License: MIT
* Changes:
*  - Wrapped in an ImprintJs promise
*/

imprint.registerTest('plugins', function() {
  return new Promise(function(resolve) {
    let results = []

    // IE
    if ((Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject')) || ('ActiveXObject' in window)) {
      const names = [
        'AcroPDF.PDF', // Adobe PDF reader 7+
        'Adodb.Stream',
        'AgControl.AgControl', // Silverlight
        'DevalVRXCtrl.DevalVRXCtrl.1',
        'MacromediaFlashPaper.MacromediaFlashPaper',
        'Msxml2.DOMDocument',
        'Msxml2.XMLHTTP',
        'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
        'QuickTime.QuickTime', // QuickTime
        'QuickTimeCheckObject.QuickTimeCheck.1',
        'RealPlayer',
        'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
        'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
        'Scripting.Dictionary',
        'SWCtl.SWCtl', // ShockWave player
        'Shell.UIHelper',
        'ShockwaveFlash.ShockwaveFlash', // flash plugin
        'Skype.Detection',
        'TDCCtl.TDCCtl',
        'WMPlayer.OCX', // Windows media player
        'rmocx.RealPlayer G2 Control',
        'rmocx.RealPlayer G2 Control.1'
      ]

      // starting to detect plugins in IE
      results = names.map(function(name) {
        try {
          // eslint-disable-next-line no-new,no-undef
          new ActiveXObject(name)
          return name
        }
        catch (e) {
          return null
        }
      })
    }

    // None IE
    if (navigator.plugins) {
      let plugins = []

      for (let i = 0, l = navigator.plugins.length; i < l; i++) {
        plugins.push(navigator.plugins[i])
      }

      // sorting plugins only for those user agents, that we know randomize the plugins
      // every time we try to enumerate them
      if (navigator.userAgent.match(/palemoon/i)) {
        plugins = plugins.sort(function(a, b) {
          if (a.name > b.name) { return 1 }
          if (a.name < b.name) { return -1 }
          return 0
        })
      }

      results = plugins.map(function(p) {
        const mimeTypes = []
        for (let i = 0; i < p.length; i++) {
          const mt = p[i]
          mimeTypes.push([mt.type, mt.suffixes].join('~'))
        }
        return [p.name, p.description, mimeTypes.join(',')].join('::')
      })
    }

    return resolve(results.join('~'))
  })
})

imprint.registerTest('processorCores', function() {
  return new Promise(function(resolve) {
    return resolve(navigator.hardwareConcurrency)
  })
})

imprint.registerTest('publicIp', function() {
  return new Promise(function(resolve) {
    const xmlHttp = new XMLHttpRequest()
    xmlHttp.onreadystatechange = function() {
      if (xmlHttp.readyState === 4 && xmlHttp.status === 200) { resolve(xmlHttp.responseText) }
    }
    xmlHttp.open('GET', 'https://api.ipify.org', true) // true for asynchronous
    xmlHttp.send(null)
  })
})

imprint.registerTest('screenResolution', function() {
  return new Promise(function(resolve) {
    const val = (window.screen.height > screen.width)
      ? [window.screen.height, window.screen.width]
      : [window.screen.width, window.screen.height]
    return resolve(val.join('x'))
  })
})

imprint.registerTest('sessionStorage', function() {
  return new Promise(function(resolve) {
    try {
      return resolve(!!window.sessionStorage)
    }
    catch (e) {
      return resolve(true) // SecurityError when referencing it means it exists
    }
  })
})

imprint.registerTest('timezoneOffset', function() {
  return new Promise(function(resolve) {
    return resolve(new Date().getTimezoneOffset())
  })
})

imprint.registerTest('touchSupport', function() {
  return new Promise(function(resolve) {
    let maxTouchPoints = 0
    let touchEvent = false

    if (typeof navigator.maxTouchPoints !== 'undefined') {
      maxTouchPoints = navigator.maxTouchPoints
    }
    else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
      maxTouchPoints = navigator.msMaxTouchPoints
    }

    try {
      document.createEvent('TouchEvent')
      touchEvent = true
    }
    catch (e) {
      /* squelch */
    }

    const touchStart = 'ontouchstart' in window

    return resolve([maxTouchPoints, touchEvent, touchStart].join('~'))
  })
})

imprint.registerTest('userAgent', function() {
  return new Promise(function(resolve) {
    return resolve(navigator.userAgent)
  })
})

/*
* Original Source: https://github.com/Valve/fingerprintjs2/blob/master/fingerprint2.js
* Copyright: Valentin Vasilyev (valentin.vasilyev@outlook.com)
* License: MIT
* Changes:
*  - Wrapped in an ImprintJs promise
*/

imprint.registerTest('webGl', function() {
  return new Promise(function(resolve) {
    try {
      const fa2s = function(fa) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0)
        gl.enable(gl.DEPTH_TEST)
        gl.depthFunc(gl.LEQUAL)
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
        return '[' + fa[0] + ', ' + fa[1] + ']'
      }
      const maxAnisotropy = function(gl) {
        const ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic')
        if (ext) {
          const anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
          return anisotropy === 0 ? 2 : anisotropy
        }
        else {
          return null
        }
      }

      const canvas = document.createElement('canvas')
      let gl = null

      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
      }
      catch (e) {
        /* squelch */
      }

      if (!gl) { return resolve('') }

      // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
      // First it draws a gradient object with shaders and convers the image to the Base64 string.
      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.
      const result = []
      const vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}'
      const fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}'
      const vertexPosBuffer = gl.createBuffer()
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer)

      const vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0])
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW)
      vertexPosBuffer.itemSize = 3
      vertexPosBuffer.numItems = 3

      const program = gl.createProgram(); const vshader = gl.createShader(gl.VERTEX_SHADER)
      gl.shaderSource(vshader, vShaderTemplate)
      gl.compileShader(vshader)

      const fshader = gl.createShader(gl.FRAGMENT_SHADER)
      gl.shaderSource(fshader, fShaderTemplate)
      gl.compileShader(fshader)
      gl.attachShader(program, vshader)
      gl.attachShader(program, fshader)
      gl.linkProgram(program)
      gl.useProgram(program)
      program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex')
      program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset')
      gl.enableVertexAttribArray(program.vertexPosArray)
      gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0)
      gl.uniform2f(program.offsetUniform, 1, 1)
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems)

      if (gl.canvas != null) {
        result.push(gl.canvas.toDataURL())
      }

      result.push('extensions:' + gl.getSupportedExtensions().join(';'))
      result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)))
      result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)))
      result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS))
      result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'))
      result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS))
      result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS))
      result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS))
      result.push('webgl max anisotropy:' + maxAnisotropy(gl))
      result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS))
      result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE))
      result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS))
      result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE))
      result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS))
      result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE))
      result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS))
      result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS))
      result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS))
      result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS))
      result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)))
      result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS))
      result.push('webgl renderer:' + gl.getParameter(gl.RENDERER))
      result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION))
      result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS))
      result.push('webgl vendor:' + gl.getParameter(gl.VENDOR))
      result.push('webgl version:' + gl.getParameter(gl.VERSION))

      try {
        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
        const extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info')
        if (extensionDebugRendererInfo) {
          result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL))
          result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL))
        }
      }
      catch (e) {
        /* squelch */
      }

      if (!gl.getShaderPrecisionFormat) { return resolve(result.join('~')) }

      result.push('webgl vertex shader high float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision)
      result.push('webgl vertex shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMin)
      result.push('webgl vertex shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMax)
      result.push('webgl vertex shader medium float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision)
      result.push('webgl vertex shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMin)
      result.push('webgl vertex shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMax)
      result.push('webgl vertex shader low float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).precision)
      result.push('webgl vertex shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMin)
      result.push('webgl vertex shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMax)
      result.push('webgl fragment shader high float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision)
      result.push('webgl fragment shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMin)
      result.push('webgl fragment shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMax)
      result.push('webgl fragment shader medium float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision)
      result.push('webgl fragment shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMin)
      result.push('webgl fragment shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMax)
      result.push('webgl fragment shader low float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).precision)
      result.push('webgl fragment shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMin)
      result.push('webgl fragment shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMax)
      result.push('webgl vertex shader high int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).precision)
      result.push('webgl vertex shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMin)
      result.push('webgl vertex shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMax)
      result.push('webgl vertex shader medium int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).precision)
      result.push('webgl vertex shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMin)
      result.push('webgl vertex shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMax)
      result.push('webgl vertex shader low int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).precision)
      result.push('webgl vertex shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMin)
      result.push('webgl vertex shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMax)
      result.push('webgl fragment shader high int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).precision)
      result.push('webgl fragment shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMin)
      result.push('webgl fragment shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMax)
      result.push('webgl fragment shader medium int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).precision)
      result.push('webgl fragment shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMin)
      result.push('webgl fragment shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMax)
      result.push('webgl fragment shader low int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).precision)
      result.push('webgl fragment shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMin)
      result.push('webgl fragment shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMax)

      return resolve(result.join('~'))
    }
    catch (e) {
      return resolve('')
    }
  })
})

let browserFingerPrint = null

export default function(browserTests) {
  if (browserFingerPrint === null) {
    if (browserTests === undefined) {
      browserTests = [
        'audio',
        'availableScreenResolution',
        'canvas',
        'colorDepth',
        'cookies',
        'cpuClass',
        'deviceDpi',
        'doNotTrack',
        'indexedDb',
        'installedFonts',
        'language',
        // "localIp",
        'localStorage',
        'pixelRatio',
        'platform',
        'plugins',
        'processorCores',
        'screenResolution',
        'sessionStorage',
        'timezoneOffset',
        'touchSupport',
        'userAgent',
        'webGl'
      ]
    }
    browserFingerPrint = imprint.test(browserTests)
      .then(buffer => {
        return [...new Uint8Array(buffer)]
          .map(b => b.toString(16).padStart(2, '0'))
          .join('')
      })
  }
  return browserFingerPrint
}
